import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Campaigns from "./components/Campaigns";
import AllCampaigns from "./components/AllCampaigns";
import Services from "./components/Services";
import Process from "./components/Process";
import Gallery from "./components/Gallery";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import MobileBar from "./components/MobileBar";

export default function Home() {
  return (
    <div className="min-w-[320px] bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Campaigns />
        <AllCampaigns />
        <Services />
        <Process />
        <Gallery />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <div className="h-[68px] lg:hidden" aria-hidden="true" />
      <MobileBar />
    </div>
  );
}